import React from 'react';
export const FormGroup = ({ children, label, errors }) => (React.createElement("div", { className: "form-group" },
    React.createElement("div", { className: "form-group__row" },
        React.createElement("div", { className: "form-group__label" },
            React.createElement("label", null, label)),
        React.createElement("div", { className: "form-group__input" }, children)),
    errors &&
        errors.map((error, idx) => (React.createElement("div", { key: idx, className: "form-group__row" },
            React.createElement("p", { className: "form-group__error" }, error))))));
//# sourceMappingURL=FormGroup.js.map